import { Box, CircularProgress } from "@mui/material";

const Loaders = () => {
    return (
        <>
            <Box
                sx={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                zIndex: 1300,
                }}
            >
                <CircularProgress color="inherit" />
            </Box>
        </>
    )
}

export default Loaders;